<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('scope.text_290')"
    icon="menu-tenant"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions
        :options="[]"
        :row="detailData"
        button-type="link"
        button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :res-id="data.id"
      :bill-id="data.id"
      :getParams="getParams"
      :on-manager="onManager"
      type="manager"
      @refresh="refresh"
      @single-refresh="singleRefresh"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import AccountDetail from '../../bill-overview/components'
import BillManagerList from '../../bill-manager/components/List'
import VoucherManagerList from '../../voucher-manager/components/List'
import RechargeRecordList from '../../recharge-record/components/List'
import IncomeExpenditureDetailsList from '../../income-expenditure-details/components/List'
import IntegralList from '../../integral/components/List'
import InvoiceApplicationList from '../../invoice-application-manager/components/List'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'

export default {
  name: 'BillAccountManagerSidePage',
  components: {
    Actions,
    AccountDetail,
    VoucherManagerList,
    RechargeRecordList,
    BillManagerList,
    IncomeExpenditureDetailsList,
    IntegralList,
    InvoiceApplicationList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('scope.text_433'), key: 'account-detail' },
        { label: this.$t('scope.text_265'), key: 'bill-manager-list' },
        { label: this.$t('scope.text_277'), key: 'voucher-manager-list' },
        { label: this.$t('scope.text_274'), key: 'income-expenditure-details-list' },
        { label: this.$t('scope.text_275'), key: 'recharge-record-list' },
        { label: this.$t('scope.text_278'), key: 'integral-list' },
        { label: this.$t('scope.text_434'), key: 'invoice-application-list' },
        { label: this.$t('scope.text_435'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'recharge-record-list') {
        return {
          billing_account_id: this.data.id,
        }
      }
      if (this.params.windowData.currentTab === 'bill-manager-list') {
        return {
          billing_account_id: this.data.id,
        }
      }
      if (this.params.windowData.currentTab === 'income-expenditure-details-list') {
        return {
          billing_account_id: this.data.id,
        }
      }
      if (this.params.windowData.currentTab === 'integral-list') {
        return {
          billing_account_id: this.data.id,
        }
      }
      if (this.params.windowData.currentTab === 'invoice-application-list') {
        return {
          billing_account_id: this.data.id,
        }
      }
      return null
    },
  },
}
</script>
